// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1lm4Q","label":"styles_label__1logr"};